import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-please-wait-nach',
  templateUrl: './please-wait-nach.component.html',
  styleUrls: ['./please-wait-nach.component.scss']
})
export class PleaseWaitNachComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
